'use client'

import { useCallback } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { Container, Grid } from '@mui/material'

// Types
import type { PageProps } from '@/types/components/pages'

// Configurations
import Config from '@/config'

// Helpers
import Cookies from '@/helpers/cookies'

// Components
const PrimaryButtonAtom = dynamic(() => import('@/components/atoms/button/primary'))
const TitleTypographyAtom = dynamic(() => import('@/components/atoms/typography/title'))
const ParagraphTypographyAtom = dynamic(() => import('@/components/atoms/typography/paragraph'))
const ErrorIconAtom = dynamic(() => import('@/components/atoms/icon/bulk/error'))
const LinkIconAtom = dynamic(() => import('@/components/atoms/icon/two-tone/link'))

const NotFoundPage = (props: PageProps) => {
	// Props
	const { lng, locale } = props

	// Callbacks
	const refreshPage = useCallback(() => {
		// Remove cookies
		Cookies.remove(`${Config.shortName}-business-alias`)
		Cookies.remove(`${Config.shortName}-business-name`)
		Cookies.remove(`${Config.shortName}-business-branch-code`)
		Cookies.remove(`${Config.shortName}-business-branch-name`)

		// eslint-disable-next-line @next/next/no-location-assign-relative-destination -- intentional hard reload so cookie removal takes effect
		window.location.href = `/${lng}`
	}, [lng])

	return (
		<Grid sx={{ bgcolor: 'background.default' }}>
			<Container maxWidth="xs" sx={{ display: 'flex', alignItems: 'center', height: '100dvh' }}>
				<Grid
					container
					spacing={2}
					sx={{
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						width: 1
					}}
				>
					<Grid>
						<ErrorIconAtom color="primary" sx={{ fontSize: 100 }} />
					</Grid>

					<Grid>
						<TitleTypographyAtom text={locale.common.title.notFound} />
					</Grid>

					<Grid>
						<ParagraphTypographyAtom text={locale.common.description.notFound} />
					</Grid>

					<Grid>
						<Link href={`/${lng}`} onClick={refreshPage}>
							<PrimaryButtonAtom text={locale.form.button.goToHome} startIcon={<LinkIconAtom />} color="primary" />
						</Link>
					</Grid>
				</Grid>
			</Container>
		</Grid>
	)
}

export default NotFoundPage
